import { Form } from 'factorial-form'

class ManualIncidenceForm extends Form {
  constructor(values: object) {
    super(values, {
      id: 'string',
      legal_entity_id: 'string',
      subject: 'string',
      description: 'string',
      effective_on: 'date',
      employee_id: 'string',
    })
  }
}

export default ManualIncidenceForm
